import { render, staticRenderFns } from "./archived_projects_empty_state.vue?vue&type=template&id=3142d4ee"
import script from "./archived_projects_empty_state.vue?vue&type=script&lang=js"
export * from "./archived_projects_empty_state.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports